module.exports = __webpack_public_path__ + "img/ic-packaging.25dcb340.svg";